"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateAllPhysicsTick = exports.render = exports.createBasic = exports.createBoundary = exports.killAll = exports.get = void 0;
var minigolfCamera_sidecar_1 = require("../camera/minigolfCamera-sidecar");
var minigolfDefs_1 = require("../defs/minigolfDefs");
var minigolfDefs_sidecar_1 = require("../defs/minigolfDefs-sidecar");
var battlescapeMap_sidecar_1 = require("../levelgen/battlescapeMap-sidecar");
var minigolfPhysics_rapier_loader_sidecar_1 = require("../physics/minigolfPhysics_rapier_loader-sidecar");
var namespace = 'minigolf-boundaries';
var _obj = null;
var get = function () {
    if (!_obj) {
        _obj = {
            rigidBodys: [],
        };
    }
    return _obj;
};
exports.get = get;
var killAll = function () {
    var e_1, _a;
    var phys = minigolfPhysics_rapier_loader_sidecar_1.minigolfPhysics_rapier_loader.get();
    var world = phys.world;
    var obj = exports.get();
    try {
        for (var _b = __values(obj.rigidBodys), _c = _b.next(); !_c.done; _c = _b.next()) {
            var rb = _c.value;
            world.removeRigidBody(rb);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    obj.rigidBodys = [];
};
exports.killAll = killAll;
var createBoundary = function (x1, y1, x2, y2) {
    var width = Math.abs(x2 - x1);
    var height = Math.abs(y2 - y1);
    var halfX = (x1 + x2) / 2;
    var halfY = (y1 + y2) / 2;
    var phys = minigolfPhysics_rapier_loader_sidecar_1.minigolfPhysics_rapier_loader.get();
    var RA = phys.RA, world = phys.world;
    // Convert tiles to physics
    var center = minigolfCamera_sidecar_1.minigolfCamera.tileToPhysics(halfX, halfY);
    var size = minigolfCamera_sidecar_1.minigolfCamera.tileToPhysics(width, -height); // Have to flip height due to flipping of y (or size is negative)
    // console.log('boundary size', size, width, height)
    var boundary_rigidBodyDesc = RA.RigidBodyDesc.fixed().setTranslation(center.x, center.y);
    var boundary_rigidBody = world.createRigidBody(boundary_rigidBodyDesc);
    var boundary_colliderDesc = RA.ColliderDesc.cuboid(size.x / 2, Math.abs(size.y / 2));
    var boundary_collider = world.createCollider(boundary_colliderDesc, boundary_rigidBody);
    boundary_collider.setCollisionGroups(minigolfDefs_1.CollisionGroups.all);
    boundary_rigidBody.userData = { type: 'boundary' };
    exports.get().rigidBodys.push(boundary_rigidBody);
    // console.log(
    //   'boundary created',
    //   boundary_rigidBody,
    //   boundary_collider,
    //   center,
    //   size,
    // )
};
exports.createBoundary = createBoundary;
var createBasic = function () {
    // Create square boundaries
    var widthInTiles = battlescapeMap_sidecar_1.battlescapeMap.sectionSize * minigolfDefs_sidecar_1.minigolfDefs.widthInSections;
    var heightInTiles = battlescapeMap_sidecar_1.battlescapeMap.sectionSize * minigolfDefs_sidecar_1.minigolfDefs.heightInSections;
    // let physicsTileSize = minigolfCamera.physicsTileSize
    // let wallThickness = physicsTileSize
    // let wallLengthH = widthInTiles * physicsTileSize
    // let wallLengthV = heightInTiles * physicsTileSize
    var tileOffset = 1 + 0.5;
    var tileOffset2 = 0.5;
    exports.createBoundary(0, -tileOffset, widthInTiles, -tileOffset2);
    exports.createBoundary(0, heightInTiles + tileOffset - 1, widthInTiles, heightInTiles + tileOffset2 - 1);
    exports.createBoundary(-tileOffset, 0, -tileOffset2, heightInTiles);
    exports.createBoundary(widthInTiles - 1 + tileOffset, 0, widthInTiles - 1 + tileOffset2, heightInTiles);
    // createBoundary(1, 1, 3, 3)
    // createBoundary(0, 0, 1, 1)
    //
    // for (let i = 0; i < 4; i++) {
    //   // let squareOffset = worldSize / 2 + borderAdjust
    //   let boundary_rigidBodyDesc = RA.RigidBodyDesc.fixed().setTranslation(
    //     squareBoundaryMultipliers[i][0] * wallLengthH,
    //     squareBoundaryMultipliers[i][1] * wallLengthV,
    //   )
    //   let boundary_rigidBody = world.createRigidBody(boundary_rigidBodyDesc)
    //   let boundary_colliderDesc = RA.ColliderDesc.cuboid(
    //     squareSizes[i][0] / 2,
    //     squareSizes[i][1] / 2,
    //   )
    //   let boundary_collider = world.createCollider(
    //     boundary_colliderDesc,
    //     boundary_rigidBody,
    //   )
    //   // boundary_collider.setCollisionGroups(
    //   //   CollisionGroups.playarea + CollisionGroups.gutter,
    //   // )
    //   boundary_rigidBody.userData = { type: 'boundary' }
    // }
    // // Create angle boundaries
    // let angleBoundaryMultipliers = [
    //   [-1, 1],
    //   [1, 1],
    //   [1, -1],
    //   [-1, -1],
    // ]
    // for (let i = 0; i < 4; i++) {
    //   let angleOffset = (worldSize / 2) * 0.7441
    //   let boundary_rigidBodyDesc = RA.RigidBodyDesc.fixed()
    //     .setTranslation(
    //       angleOffset * angleBoundaryMultipliers[i][0],
    //       angleOffset * angleBoundaryMultipliers[i][1],
    //     )
    //     .setRotation((turn * 1) / 8 + (turn * i) / 4)
    //   let boundary_rigidBody = world.createRigidBody(boundary_rigidBodyDesc)
    //   let boundary_colliderDesc = RA.ColliderDesc.cuboid(
    //     wallLength / 2,
    //     wallThickness / 2,
    //   )
    //   let boundary_collider = world.createCollider(
    //     boundary_colliderDesc,
    //     boundary_rigidBody,
    //   )
    //   boundary_collider.setCollisionGroups(
    //     CollisionGroups.playarea + CollisionGroups.gutter,
    //   )
    //   boundary_rigidBody.userData = { type: 'boundary' }
    // }
};
exports.createBasic = createBasic;
var render = function () { };
exports.render = render;
var updateAllPhysicsTick = function () { };
exports.updateAllPhysicsTick = updateAllPhysicsTick;
